import React from "react";
import styles from "../Applicants/Table/Table.module.css";

const StatusContainer = ({ status }) => {
  const calssStatus = (status) => {
    switch (status) {
      case "Prospect":
        return "prospect";
      case "Not Interested":
        return "not-interested";
      case "Interested":
        return "interested";
      case "Converted" || "4":
        return "converted";
      case "Applicant":
        return "applicant";
    }
  };
  const classCircle = (status) => {
    switch (status) {
      case "Prospect":
        return "prospectCircle";
      case "Not Interested":
        return "not-interestedCircle";
      case "Interested":
        return "interestedCircle";
      case "Converted" || "4":
        return "convertedCircle";
      case "Applicant":
        return "applicantCircle";
    }
  };

  return (
    <span className={styles[`${calssStatus(status)}`]}>
      <span className={styles[`${classCircle(status)}`]}></span>
      {status}
    </span>
  );
};

export default StatusContainer;
